module.exports = __webpack_public_path__ + "assets/img/bld.e0766d5b.png";